import React from 'react'
import { t } from '../../../utilities/translator';
import { IMAGE_CDN } from '../../../constants/constants';
import { getImage } from '../../../utilities/iconResolver';
import { WithTooltip } from '../../../components/tooltip/WithTooltip';
import { tr } from 'date-fns/locale';
const env = import.meta.env.MODE;

const DealFlight = ({ flight, nightFlight, stickers, dealDeparture }) => {
  const {
    city_from_airport_code,
    city_to_airport_code,
    takeoff_hour,
    landing_hour,
    nb_escales,
    comp_path,
    comp_logo,
    company_name = '',
    company_name: outboundCompanyName,
    inbound: { company_name: inboundCompanyName },
  } = flight;
  const differentAirlines = outboundCompanyName !== inboundCompanyName;

  return (
    <div className="deal-flight flex justify-between items-end">
      <div className="flex gap-2">
        {comp_logo && comp_path && (
          <>
            <img
              src={`${
                env === 'development' ? 'https://d16tr0byigrcd.cloudfront.net/hf' : IMAGE_CDN.replace('/images', '')
              }${comp_path}${comp_logo}`}
              alt="air company logo"
              data-tip={differentAirlines ? t('multipleAirlinesTooltip') : company_name}
              className="h-7 w-7 object-cover rounded air-company-logo"
            />
          </>
        )}
        <WithTooltip text={`${t('dealItem.departingFrom')} ${(dealDeparture && dealDeparture.length > 0) ? `${dealDeparture[0].value} - ` : ''}${city_from_airport_code}`}>
          <div className="flex flex-col gap-1 caption-strong text-start">
            <span className="leading-none">
              {nb_escales === 0
                ? t('dealItem.direct_flight')
                : `${nb_escales} ${t('dealItem.stops_plural', { count: nb_escales })}`}
            </span>
            <span className="flex items-center gap-1 leading-none">
              <span>{takeoff_hour} {city_from_airport_code}</span>
              <span> - </span>
              <span>{landing_hour} {city_to_airport_code}</span>
            </span>
          </div>
        </WithTooltip>
      </div>
      <div className="deal-item-bottom-icons flex items-center">
        {nightFlight && <i className="ri-contrast-2-fill items-center text-lg leading-none" />}
        {stickers.carryOnTrolleyIncluded ? (
          <WithTooltip text={t('dealItem.trolleyIncluded')}>
            <img src={getImage('hf-trolley-bag-new.svg')} alt={t('dealItem.trolleyIncluded')} className="deal-baggage-icon" />
          </WithTooltip>
        ) : null}
        {stickers.luggageIncluded ? (
          <WithTooltip text={t('dealItem.checkedBaggageIncluded')}>
            <img src={getImage('hf-checked-bag-new.svg')} alt={t('dealItem.checkedBaggageIncluded')} className="deal-baggage-icon" />
          </WithTooltip>
        ) : null}
      </div>
    </div>
  )
}

export default DealFlight
